import { Context, CustomQuery } from '@vue-storefront/core';
type LoginResponse = {
  token: string;
}

export default async function guestLogin({ client, config }: Context, params: CustomQuery): Promise<LoginResponse> {
  const url = new URL('/mall/guest/login', config.api.url);
  const result = await client.get(url.href, {params});
  if (result?.data && result?.data?.data && result?.data?.data?.token) {
    config.auth.setToken(result?.data?.data.token);
  }
  return result?.data?.data;
}
